module.exports = __webpack_public_path__ + "static/media/banner_news_raio_de_atuacao.e1826968.png";